import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";
import PosModelFields from "./PosModelFields";

export default function EditPosModel() {
  const data = useLoaderData();
  const loadFn = (form) => form.setFieldsValue(data);
  return (
    <SimpleFormPage
      title="Modifica modello POS"
      loadFn={loadFn}
      transformData={(form) => ({
        ...form,
        ref: data.ref,
        formItems: form.formItems ?? [],
        sections: form.sections ?? [],
      })}
    >
      <PosModelFields />
    </SimpleFormPage>
  );
}
